<template>
  <div class="settings-header">
    <!-- Back -->
    <button class="back" type="button" @click="$emit('back')">
      <i class="fa-regular fa-chevron-left back__icon"></i>
      <span class="back__text">{{ backTextComputed }}</span>
    </button>

    <!-- Title / subtitle -->
    <h1 class="title">{{ title }}</h1>
    <p v-if="description" class="subtitle">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "SettingsHeader",
  props: {
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    backText: { type: String, default: "" },
  },
  computed: {
    backTextComputed() {
      return this.backText || "Go Back to Competition";
    },
  },
};
</script>

<style scoped lang="scss">
.settings-header {

  padding: 10px 0 18px;
}

/* Back link */
.back {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  background: transparent;
  border: 0;
  padding: 0;
  margin: 0 0 18px; 

  cursor: pointer;
  color: #9aa0a6;
  font-family: "Avenir", sans-serif;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    opacity: 0.85;
  }

  &:focus {
    outline: none;
  }
}

.back__icon {
  font-size: 12px;
  line-height: 1;
  color: inherit;
}

.back__text {
  line-height: 1;
}

/* Title */
.title {
  font-family: "Aeonik", "Avenir", sans-serif !important;
  font-weight: 800 !important;
  font-size: 38px !important;
  line-height: 1.4 !important;

}

/* Subtitle */
.subtitle {
  // margin: 10px 0 0;
  font-family: "Avenir", sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #6c757d;
}


:deep(.theme--dark) .title {
  color: #ffffff;
}
:deep(.theme--dark) .subtitle {
  color: #adb5bd;
}
:deep(.theme--dark) .back {
  color: #c1c7cd;
}
</style>
